import React, { useEffect, useState } from "react";

import Button from '../../../../../../../../../components/Button';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appActionCreators from '../../../../../../../../../services/app/actions';

import { useNavigate, useParams } from  'react-router-dom';
import { useFeathers } from "../../../../../../../../../FeathersProvider";

const Quiz = props => {

  const feathers = useFeathers();

  const navigate = useNavigate();

  const { gameId, blockId, questionId } = useParams();

  const { clinicalCase, block, question, setLoading } = props;


  useEffect(() => {
    setLoading(true);
  }, []);

  const index = block.questions.findIndex(q => q.id == questionId);

  let next = '/';

  const game = props.manifest.games.find(g => g.id == gameId);
  const caseIndex = game.cases.findIndex(cc => cc.id == clinicalCase.id);
  const blockIndex = clinicalCase.blocks.findIndex(b => b.id == blockId);



  return (
    <React.Fragment>
      <iframe
        title="Intro"
        className='body grow m-12 mb-8'
        src={question.ko}
        onLoad={ () => setLoading(false) }
      />
      <div className='footer flex shrink-0 justify-center'>
        <Button
          className='btn-secondary -translate-y-5 mx-4'
          onClick={() => {
            navigate(`/${gameId}/game/case/${clinicalCase.id}/block/${block.id}/question/${question.id}`)
          }}
        >&lt; Intentar de nuevo</Button>
        <Button
          className='btn-secondary -translate-y-5'
          onClick={async () => {
            if (block.questions.length > index + 1) { // If more questions in this block
              next = `/${gameId}/game/case/${clinicalCase.id}/block/${block.id}/question/${block.questions[index+1].id}`;
            } else if (clinicalCase.blocks.length > blockIndex + 1) { // More blocks in this case
              next = `/${gameId}/game/case/${clinicalCase.id}/block/${block.id}/outro`;
            } else if (game.cases.length > caseIndex + 1) { // No more blocks but another case
              next = `/${gameId}/game/case/${clinicalCase.id}/block/${block.id}/outro`;
            } else { // No more blocks nor cases
              next = `/${gameId}/game/finalko`;

              const r = await feathers.patch("gameplays", props.currentGame._id, {
                code: props.currentGame.code,
                finalTime: new Date(props.currentGame.endTime).getTime() - new Date().getTime(),
                endTime: null,
                score: props.currentGame.score
              });
              props.actions.app.update({ currentGame: r });
            }
            navigate(next)
          }}
        >Continuar &gt;</Button>
        {question.study ?
          <Button
            className='btn-secondary -translate-y-5 mx-4'
            onClick={() => {
              props.actions.app.update({ rightModal: { visible: true, tip: false, url: question.study } });
            }}
          >Estudio</Button>
        : null }

      </div>
    </React.Fragment>
  );
};

export default connect(
  (state, ownProps) => ({
    feathersUser: state.services.app.feathersUser,
    manifest: state.services.app.manifest,
    currentGame: state.services.app.currentGame,
  }),
  dispatch => ({
    actions: {
      app: bindActionCreators(appActionCreators, dispatch)
    }
  })
)(Quiz);